import { CssBaseline } from '@material-ui/core';
import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Initialize from './containers/Initialize';
import store from './store';
import MainRouter from './components/MainRouter';
import ThemeProvider from './context/theme/ThemeProvider';
import OAuthRedirectMessage from './components/Auth/OAuth/OAuthRedirectMessage';
import AuthSessionResponder from './components/Auth/AuthSessionResponder';

const App = () => (
  <Provider store={store}>
    <AuthSessionResponder />
    <ThemeProvider>
      <ToastContainer />
      <CssBaseline />
      <Router>
        <OAuthRedirectMessage>
          <Initialize>
            <MainRouter />
          </Initialize>
        </OAuthRedirectMessage>
      </Router>
    </ThemeProvider>
  </Provider>
);

export default App;
